/* esm.sh - unhead@3.1.0/dist/shared/unhead.DiRbsb3I */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.DiRbsb3I.mjs";
